/**
 * Role dropdown options for the stakeholder form. Sourced from the
 * Stakeholder Notification Matrix (sheet 1) across the 10 incident types.
 * Internal = company staff/leadership/teams. External folds in vendors,
 * regulators, and community roles per Yash's spec ("just Internal and
 * External, don't need Regulatory / Community as separate tabs").
 */

export const INTERNAL_STAKEHOLDER_ROLES: string[] = [
  'Board',
  'Board Chair',
  'CEO',
  'Executive Team',
  'WHS Manager',
  'HR',
  'Legal',
  'Communications',
  'Marketing',
  'Facilities',
  'Operations',
  'Security',
  'IT / CIO',
  'Cyber Team',
  'Risk',
  'Risk Committee',
  'Internal Audit',
  'Compliance',
  'Finance',
  'Payroll',
  'Supervisors',
  'Staff welfare team',
  'Staff (involved)',
  'Other internal',
];

export const EXTERNAL_STAKEHOLDER_ROLES: string[] = [
  // Commercial / vendors
  'Insurer',
  'Cyber insurer',
  'Landlord',
  'Utilities provider',
  'Fire contractor',
  'Security contractor',
  'Site contractor',
  'Managed IT provider',
  'Forensic investigator',
  'External investigator',
  'Legal counsel',
  'Auditor',
  'PR firm',
  'EAP provider',
  'Medical provider',
  'Platform representative',
  'Venue operator',
  'Transport provider',
  'Restoration contractor',
  'Supplier',
  'Vendor',
  'Contractor (general)',
  // Community / social
  'Customer',
  'Family / Next of Kin',
  'Neighbour',
  'Community member',
  'Partner',
  'Shareholder',
  'Investor',
  'Union',
  'Media',
  // Regulatory / government / emergency
  'Fire and Rescue NSW',
  'SafeWork NSW / WorkSafe',
  'Police Force',
  'Ambulance',
  'State Emergency Service (SES)',
  'Coroner',
  'Local Council',
  'Australian Cyber Security Centre (ACSC)',
  'Office of the Australian Information Commissioner (OAIC)',
  'Australian Securities and Investments Commission (ASIC)',
  'Independent Commission Against Corruption (ICAC)',
  'Australian Competition and Consumer Commission (ACCC)',
  'eSafety Commissioner',
  'Industry regulator',
  'Other external',
];
